<header
  class="header"
  [class.header--filled]="!transparentNav"
  [class.header--color-only]="!media?.absoluteUrl"
  [ngClass]="!transparentNav && (media?.absoluteUrl || imageUrl) ? 'palette-pink' : ''"
  [attr.data-background-position]="media?.anchor"
  #headerEl
>
  <img
    class="object-fit-cover"
    [ngSrc]="media?.absoluteUrl || imageUrl"
    [fill]="true"
    [priority]="true"
    [attr.data-object-position]="media?.anchor || 'middlecenter'"
    [loaderParams]="{
      anchor: media?.anchor || 'middlecenter',
      mode: 'crop',
      format: 'webp',
    }"
    [alt]="media?.altText || title"
  />
  <!-- [ngStyle]="{ 'background-image': 'url(' + image?.url + ')' }" -->
  <div class="container">
    <div class="row">
      <main class="header__content col-md-6 col-xl-5 section-inset-y" [class.mt-4]="transparentNav" #headerElMain>
        @if (subtitle) {
          <strong class="fw-semi text-max-width-xs text-background-text-color">
            {{ subtitle }}
          </strong>
        }
        @if (title && isSlider) {
          <h2 class="h1 text-background-text-color text-max-width-xs">
            {{ title }}
          </h2>
        }
        @if (title && !isSlider) {
          <h1 class="h1 text-background-text-color text-max-width-xs">
            {{ title }}
          </h1>
        }
        @if (text) {
          <p class="text-max-width-xs fw-normal mb-0">
            {{ text }}
          </p>
        }

        <!-- Button -->
        @if (button?.url) {
          <a class="button button--secondary mt-4" [href]="button?.url">
            <span>{{ button?.text || 'Shop nu' }}</span>
          </a>
        }
        @if (button?.routerLink?.length && !button?.url) {
          <a class="button button--secondary mt-4" [routerLink]="button?.routerLink">
            <span>{{ button?.text || 'Shop nu' }}</span>
          </a>
        }
        <!-- Button end -->
      </main>
      <!--<figure class="header__figure col-md-6 col-xl-7" *ngIf="image?.url && transparentNav">
      <img [src]="image?.url || '' | resize: 1600:undefined:image?.anchor" [alt]="image?.alt || image?.caption || title" />
    </figure>-->
    </div>
  </div>
</header>
